/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Candle } from 'components/Candle'
import { Grid } from 'components/Grid'
import { Weekdate } from 'components/Weekdate'
import { MarkedDeath } from 'components/MarkedDeath'
import { Modal } from 'components/Modal'
import { DetailView } from 'components/DetailView'
import { CountSeparator } from 'components/CountSeparator'
import { MetaInfos } from 'components/MetaInfos'
import { Mdx } from '@ta-interaktiv/contentbricks'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import GetSheetDone from 'get-sheet-done'
import { group } from 'd3-array'
import { Coors } from './coors'
const csv = require('csvtojson')

const formatDate = {
  de: (datestring: string) => {
    return new Date(Date.parse(datestring)).toLocaleDateString('de-DE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  },
  fr: (datestring: string) => {
    return new Date(Date.parse(datestring)).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  }
}

const locales = {
  de: require('../_data/locales_fr.yml'),
  fr: require('../_data/locales_fr.yml')
}
const host = parseHostname().publicationDomain
const frenchdomains = ['tdg.ch', '24heures.ch']
const isFrench = frenchdomains.indexOf(host) !== -1
const lang: languages = isFrench ? 'fr' : 'de'
const articleId = isFrench ? '371523558250' : '350776271483'
const updateDate = '2021-03-02'

const loc = locales[lang]
const bp = window.innerWidth > 711 ? 1 : 0

const elementSizes = {
  short: bp === 0 ? 4 : 3,
  shortlong: bp === 0 ? 4 : 3,
  middle: bp === 0 ? 5 : 4,
  long: bp === 0 ? 6 : 4
}
const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return null
}

export function AppComponent() {
  const [overlaycontent, setoverlaycontent] = useState<
    MarkedInterface | undefined
  >()

  const [deathdata, setDeathData] = useState<
    {
      female: number
      male: number
      unknown: number
      week: [string, string, string, number]
      femaleAnnotations: {}[]
      maleAnnotations: {}[]
      collection?: drawDataTypes[]
    }[]
  >()
  const [drawData, setDrawData] = useState<drawDataTypes[]>()
  const [annotationData, setAnnotationData] = useState<drawDataTypes[]>()
  const directedPlacement = () => {
    if (!annotationData || !deathdata) return
    const dd: drawDataTypes[] = []
    deathdata.forEach((d, j) => {
      if (j < 2) return
      if (
        !(new Date(d.week[0]).getMonth() === new Date(d.week[1]).getMonth()) ||
        new Date(d.week[0]).getDate() === 1
      ) {
        const el: separatorType = {
          separator: d.week[3] + d.female + d.male,
          date: d.week[1]
        }
        dd.push(el)
      }
      if ((d.female > 0 || d.male > 0) && j > 1) dd.push({ week: d.week })
      for (let i = 0; i < d.female; i++) dd.push({ g: 'f' })
      for (let i = 0; i < d.male; i++) dd.push({ g: 'm' })
    })

    annotationData.forEach(d => {
      if (!d.pos) d.pos = [0, 0]

      const p = d.pos[bp]
      dd.splice(p, 1, d)
      // dd[p - 1].marked = true
    })

    setDrawData(dd)
  }

  type CollectionInfoType = {
    week: string
    male: number
    female: number
    femaleStart: Coors
    femaleEnd: Coors
    maleStart: Coors
    maleEnd: Coors
  }

  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/deathgender.json'
    )
      .then(response => {
        return response.json()
      })
      .then(input => {
        setDeathData(input)
        // fetch('[DSI] Todesfaelle - Sheet1.csv')
        //   .then(response => {
        //     return response.text()
        //   })
        //   .then(csv2 => {
        //     csv({
        //       output: 'json'
        //     })
        //       .fromString(csv2)
        //       .then((csvRow: MarkerImportType[]) => {
        //         const ad: MarkedInterface[] = csvRow
        //           .filter(f => f.type && (f.bp1 || f.bp2))
        //           .map(m => {
        //             m.pos = [+(m.bp1 || 4000), +(m.bp2 || 4000)]
        //             delete m.bp1
        //             delete m.bp2
        //             return m
        //           })
        //         setAnnotationData(ad)
        //       })
        //   })
        GetSheetDone.labeledCols(
          '1NJZvKKjGJUBov2hjTp4xXmJAKziXTyympR0OTbfrsCs',
          1
        )
          .then(
            (data: {
              title: string
              updated: string
              data: MarkerImportType[]
            }) => {
              const ad: MarkedInterface[] = data.data
                .filter(f => f.type && (f.bp1 || f.bp2))
                .map(m => {
                  m.pos = [+(m.bp1 || 4000), +(m.bp2 || 4000)]
                  delete m.bp1
                  delete m.bp2
                  return m
                })

              setAnnotationData(ad)
            }
          )
          .catch((err: Error) => {
            console.info('Error')
            console.info(err)
          })
      })
  }, [])

  useEffect(directedPlacement, [bp, annotationData])

  useEffect(() => {
    if (overlaycontent) document.body.classList.add('modalopen')
    if (!overlaycontent) document.body.classList.remove('modalopen')
  }, [overlaycontent])
  const half_length = 2071
  return (
    <div className='index'>
      <Masthead articleId={articleId} inverted />
      <ThemeSwitch />
      <ScrollToTop />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{loc.title}</h1>
            <h2>{loc.lead}</h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <MetaInfos
              authors={[
                'Catherine Boss',
                'Dominique Botti',
                'Sebastian Broschinski',
                'Marc Brupbacher',
                'Roland Gamp',
                'Simone Rau',
                'Oliver Zihlmann'
              ]}
              updated={
                loc.updated +
                ' ' +
                (isFrench
                  ? formatDate.fr(updateDate)
                  : formatDate.de(updateDate))
              }
            />
            <Mdx file={require('components/_data/intro_' + lang + '.mdx')} />
          </div>
        </div>
      </div>
      <div className='ui vertical segment'>
        <div className='gridwrapper'>
          <Grid>
            <>
              {!drawData && (
                <div className='ui vertical centered'>
                  <div
                    className='ui active dimmer'
                    style={{ textAlign: 'center' }}
                  >
                    <div className='ui text loader'>{loc.loading}</div>
                  </div>
                </div>
              )}
              {drawData &&
                loc &&
                drawData.slice(0, half_length).map((m, i) => {
                  if (m.g) {
                    const { g, marked } = m as CandleType
                    return (
                      <Candle
                        key={'candle_' + i}
                        sex={g}
                        className={marked ? ' marked' : ''}
                        pos={i}
                      />
                    )
                  } else if (m.week) {
                    const { week } = m as WeekType
                    return (
                      <Weekdate
                        key={'week_' + i}
                        data={week}
                        locale={loc.week}
                      />
                    )
                  } else if (m.separator) {
                    const sep = m as SeparatorType
                    return (
                      <CountSeparator
                        key={'separator_' + i}
                        content={sep}
                        locale={loc.separator}
                      />
                    )
                  } else if (m.name) {
                    const marker = m as MarkedInterface
                    return (
                      <MarkedDeath
                        key={'marked_' + i}
                        content={marker}
                        openmodal={setoverlaycontent}
                        locales={loc.marked}
                        pos={i}
                      />
                    )
                  }
                })}
            </>
          </Grid>
          <Grid>
            <>
              {!drawData && (
                <div className='ui vertical centered'>
                  <div
                    className='ui active dimmer'
                    style={{ textAlign: 'center' }}
                  >
                    <div className='ui text loader'>{loc.loading}</div>
                  </div>
                </div>
              )}
              {drawData &&
                loc &&
                drawData.slice(half_length).map((m, i) => {
                  if (m.g) {
                    const { g, marked } = m as CandleType
                    return (
                      <Candle
                        key={'candle_' + i}
                        sex={g}
                        className={marked ? ' marked' : ''}
                        pos={i}
                      />
                    )
                  } else if (m.week) {
                    const { week } = m as WeekType
                    return (
                      <Weekdate
                        key={'week_' + i}
                        data={week}
                        locale={loc.week}
                      />
                    )
                  } else if (m.separator) {
                    const sep = m as SeparatorType
                    return (
                      <CountSeparator
                        key={'separator_' + i}
                        content={sep}
                        locale={loc.separator}
                      />
                    )
                  } else if (m.name) {
                    const marker = m as MarkedInterface
                    return (
                      <MarkedDeath
                        key={'marked_' + i}
                        content={marker}
                        openmodal={setoverlaycontent}
                        locales={loc.marked}
                        pos={i}
                      />
                    )
                  }
                })}
            </>
          </Grid>
          {overlaycontent && (
            <Modal closemodal={setoverlaycontent} locale={loc.close}>
              <DetailView content={overlaycontent} lang={lang} />
            </Modal>
          )}
        </div>
        {!isFrench && (
          <div className='ui text container'>
            <iframe
              height='200px'
              width='100%'
              frameBorder='no'
              scrolling='no'
              seamless
              src='https://player.simplecast.com/736867d8-8cad-4c6b-808d-cc759edbaaa0?dark=true&color=121212'
              style={{ marginTop: '4em' }}
            />
          </div>
        )}
      </div>

      <Footer
        hidePortfolioTeaser
        locale={lang}
        articleId={articleId}
        questions={loc.questions}
        credits={[
          [
            loc.credits.research,
            'Simone Rau, Dominique Botti, Catherine Boss, Oliver Zihlmann, Roland Gamp'
          ],
          [loc.credits.conception, 'Sebastian Broschinski, Marc Brupbacher'],
          [loc.credits.coop, 'Susanne Wenger']
        ]}
        inverted
      />
    </div>
  )
}
